<template>
  <div class="not-found">
    <h1>404 File Not found</h1>
    <p>お探しのページは見つかりませんでした。</p>
    <p>一時的にアクセスできない状況にあるか、移動もしくは削除された可能性があります。</p>
    <p>もう一度URLが正しいかお確かめください。</p>
  </div>
</template>
<script>
export default {
  name: 'not-found'
}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue